import { Button } from "@mui/material";
import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import SmallModal from "../Modal/SmallModel";

const SubmitButton = (props) => {
  const { name, styles, handleAction, systemSettings, variant, setConfirm, confirm, handleClick,title,startIcon,color } = props;
  const mainBackground = systemSettings?.mainBackground;

  return (
    <>
      <SmallModal
        select={confirm}
        setSelect={setConfirm}
        confirm={handleAction}>
        <i className="fa fa-check-circle fa-4x text-success me-2" />
        <span>{title ?? "Do you want to submit this form?"}</span>
      </SmallModal>
      <Button
        onClick={handleClick}
        type="submit"
        size={"small"}
        variant={variant??"contained"}
        // style={{
          style={{ backgroundColor: mainBackground}}
        // }}
        color={color??'primary'}
        startIcon={startIcon??null}
        className={`${styles}`}>
        {name}
      </Button>
    </>
  );
};
export default connect(mapStateToProps)(SubmitButton);
